export enum Path {
  HOMEPAGE = "/",
  SIGNIN = "/sign-in",
  SENDEMAIL = "/send-email",
}
